'use client'

import {ReactNode, useState} from 'react'
import {AccordionState} from '../../enums'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {InitialState} from '../../types'

type Props = {
  initialState: InitialState
  children: ReactNode
  layout: string
  id: number
  className?: string
}

const AccordionHeadWrapper = ({initialState, children, layout, id, className}: Props) => {
  const [isOpen, setIsOpen] = useState(initialState === AccordionState.InitialOpen)

  const handleOnClick = () => {
    if (initialState !== AccordionState.AlwaysOpen) {
      if (isOpen) {
        triggerAnalytics('text-component-collapsed', {
          'accordion-id': id,
          layout: layout,
        }).sendAll()
      } else {
        triggerAnalytics('text-component-expanded', {
          'accordion-id': id,
          layout: layout,
        }).sendAll()
      }
      setIsOpen((prevState) => !prevState)
    }
  }

  return (
    <div onClick={handleOnClick} className={className}>
      {children}
    </div>
  )
}

export default AccordionHeadWrapper
